@if (cropField() && !isLoading()) {
  <specific-form-header-section
    [title]="'TGA.Advice.Planting.Title' | translate"
    [cropYear]="cropYear"
    [cropField]="cropField()!"
  ></specific-form-header-section>
  <app-risk-analysis [translationParams]="translationParams()" [adviceLines]="plantingAdvice()"></app-risk-analysis>
} @else if (isLoading()) {
  <div class="loading-container">
    <app-loading-card [loadingText]="'BFP.UI.Loading'" />
  </div>
}
